import { useAnimalNuisanceStore } from '@animal-nuisance/hooks/useAnimalNuisanceStore';

export interface PayloadObject {
  ReportObject: ReportObject;
  ServiceLocationObject: ServiceLocationObject;
  ChannelObject: ChannelObject;
  ReporterObject: ReporterObject;
  FileCollectionObject: FileCollectionObject | null | undefined;
}

export interface ReportObject {
  issue_types: string[];
  description: string;
  recurring: boolean;
  recurring_time: string;
}

export interface ServiceLocationObject {
  address_line_1: string;
  address_line_2: string;
  town_city: string;
  county: string;
  postcode: string;
  country: string;
  UPRN: string;
  USRN: string;
  latitude: number;
  longitude: number;
  easting: string;
  northing: string;
  additional_details: string;
  is_commercial: boolean;
  is_within_borough: boolean;
}

export interface Asset {
  asset_id: string;
  layer_id: number;
}

export interface ChannelObject {
  channel: string;
  platform: string;
  session_id: string;
}

export interface ReporterObject {
  can_be_contacted: boolean;
  can_back_office_contact: boolean;
  contact_id: string | null;
  name: Name;
  contact_details: ContactDetails | null;
}

export interface Name {
  first_name: string;
  middle_name: string;
  last_name: string;
}

export interface ContactDetails {
  email_address: string;
  phone_number: string;
}

export interface FileCollectionObject {
  external: boolean;
  files: File[];
}

export interface File {
  name: string;
  path: string;
}

export const AnimalNuisancePayload = (): PayloadObject => {
  const {
    data: {
      userDetails: { firstName, lastName, email },
      issueTypes,
      issueInfo,
      serviceLocationDetails,
      issueLocationMoreInfo,
      uploadedImagesBlob,
      sessionId,
      recurringIssue: { isRecurringIssue, whenDidItHappen },
      wantConfirmationEmail,
      canBeContacted,
    },
  } = useAnimalNuisanceStore.getState();

  const {
    address_line_1,
    address_line_2,
    town_city,
    county,
    postcode,
    country,
    UPRN,
    USRN,
    latitude,
    longitude,
    easting,
    northing,
  } = serviceLocationDetails;

  let uploadedFiles: { name: string; path: string }[] = [];
  uploadedImagesBlob?.forEach((file) => {
    uploadedFiles.push({
      name: file.filename,
      path: file.blob_uri,
    });
  });

  const payload = {
    ReportObject: {
      issue_types: issueTypes.map((type) => type.name),
      description: issueInfo,
      recurring: isRecurringIssue,
      recurring_time: whenDidItHappen,
    },

    ServiceLocationObject: {
      address_line_1,
      address_line_2,
      town_city,
      county,
      postcode,
      country,
      UPRN,
      USRN,
      easting,
      northing,
      latitude,
      longitude,
      additional_details: issueLocationMoreInfo,
    },
    ChannelObject: {
      channel: 'Online',
      platform: 'React',
      session_id: sessionId,
    },
    ReporterObject: {
      can_be_contacted: wantConfirmationEmail,
      can_back_office_contact: canBeContacted,
      contact_id: null,
      name: {
        first_name: firstName,
        middle_name: '',
        last_name: lastName,
      },
      contact_details: {
        email_address: email,
        phone_number: '',
      },
    },
    ...(uploadedFiles?.length > 0 && {
      FileCollectionObject: {
        external: false,
        files: uploadedFiles,
      },
    }),
  };
  return payload as PayloadObject;
};
